<div class="classification-indicator-question">
    <!-- {{question.taskId}} -->
    <div id="question" class="card" [class.borderInlineStart]="question.hasComments"
        [class.errorBorderInlineStart]="!question.isValid" 
        [class.hasChangeBorderInlineStart]="question.hasChange">
        <div class="row align-items-start">
            <div class="col-sm-6">
                <h6>
                    {{question.code}}
                    <span class="separator"></span>
                    <span [innerHTML]="question.name"></span>
                </h6>
                <p >{{question.description}}</p>
                <div *ngIf="question.hasError" class="error">
                    {{question.error}}
                </div>
            </div>
            <br />
            <div class="col-sm-6">
                &nbsp;&nbsp;<input type="checkbox" id="question_{{question._id}}" [(ngModel)]="question.notApply"
                    [disabled]="viewOnly" (change)="changeApply()">
                &nbsp;<label for="question_{{question._id}}"
                    [ngClass]="{'answered-label' : question.notApply && viewOnly}">{{'forms.common.a1' |
                    translate}}</label>
            </div>
        </div>

        <div class="custom-question-tooltip {{question.tooltip && !data.options.hideComments ? 'cp68' : 'cp40'}}">
            <div class="comments" *ngIf="!data.options.hideComments" [matMenuTriggerFor]="commentsMenu"
                #menuTrigger="matMenuTrigger" (menuClosed)="isCommentsOpen = false"
                (menuOpened)="isCommentsOpen = true">
                <i class="fa fa-comments"></i>
            </div>
            <div class="tip" *ngIf="question.tooltip" (click)="showDialog(question.tooltip)" mat-raised-button matTooltip="{{ question.tooltip | translate}}">
                <i class="fa fa-info"></i>
            </div>

            <mat-menu #commentsMenu="matMenu" class="comments-menu">
                <app-classification-comments *ngIf="isCommentsOpen" [questionId]="question._id" [domainId]="domain._id"
                    [dir]="dir" [data]="data" [indicator]="indicator" (click)="$event.stopPropagation();"
                    (onClose)="closeMenu()" (onHistoryUpdated)="historyUpdated()">
                </app-classification-comments>
            </mat-menu>
        </div>

        <ng-container *ngIf="!question.notApply">
            <ng-container *ngIf="question.type == 'years';else normal">
                <table class="table table-bordered z-99">
                    <tr *ngFor="let year of question.years">
                        <td colspan="2">
                            {{year.name}}
                        </td>
                        <td width="35%" class="input">
                            <input type="number" [min]="question.min || 0" required class="form-control"
                                [(ngModel)]="year.value" [disabled]="viewOnly || question.notApply"
                                (blur)="checkYearInput($event,year)" />
                        </td>
                    </tr>
                </table>
            </ng-container>
            <ng-template #normal>
                <div class="row z-99">
                    <div class="col-sm-6">
                        <input type="number" [min]="question.min || 0" [max]="question.max"
                            [step]="question.type == 'int' ? 1 : 0.01" required class="form-control"
                            [(ngModel)]="question.score" [disabled]="viewOnly || question.notApply"
                            (blur)="checkValue($event)" />

                        <div *ngIf="question.score < question.min || 0" class="error input-error">
                            {{'forms.common.The value must be greater than or equal' | translate}} : {{question.min}}
                        </div>
                        <div *ngIf="question.score > question.max" class="error input-error">
                            {{'forms.common.The value must be less than or equal' | translate}} : {{question.max}}
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-container *ngIf="question.hasAttachments">
                <div *ngIf="formReady" class="attachment-container {{showForm ? '' : 'd-none'}}">
                    <div class="header">
                        <label class="label" [class.field-required]="question.attachmentIsRequired" [innerHTML]="question.attachmentName">
                        </label>
                        <i class="fas fa-info-circle iconTooltip" *ngIf="question.attachmentsTooltip"
                            matTooltip="{{question.attachmentsTooltip}}"></i>
                    </div>

                    <formio #forms [style.margin-top]="viewOnly || question.notApply ? '-25px' : '-65px'"
                        [loadingFormHidden]="false" [submission]="{data:{attachments : question.attachmentsFiles }}"
                        [formKey]="attachmentsFormKey" [showLoader]="false" (formLoad)="formLoad($event)"
                        [readOnly]="viewOnly || question.notApply" [viewOnly]="viewOnly || question.notApply">
                    </formio>
                </div>
            </ng-container>
        </ng-container>

        <label class="label" for="questionNotes" [class.field-required]="question.notApply">
            {{'forms.common.Notes' | translate}}
        </label>
        <p-editor name="questionNotes" [style]="{'height':'100px'}" [required]="question.notApply"
            [(ngModel)]="question.notes" [readonly]="viewOnly">
        </p-editor>


        <div style="text-align: end;" *ngIf="!viewOnly">
            <button class="dialog-button dialog-save" [disabled]="!question.isValid" (click)="save();">
                {{'forms.common.save' | translate}}
            </button>
        </div>
    </div>
</div>